import React, { useEffect, useState } from 'react';
import PrimaryButton from '../../../Common/Button/PrimaryButton';
import { Box, useMediaQuery } from '@mui/material';
import jsPDF from 'jspdf';
import { useSelector } from 'react-redux';
import { downloadPDF } from '../../../../utils/dowloadPdf';
import { downloadWordFile } from '../../../../utils/downloadWordfrompdf';
import { useQueryParameters } from '../../../Common/useQueryParameters';
import { mapTables } from '../../../../utils/MapTables';
import { PDFDocument } from 'pdf-lib';
function CKEditoruploadcomp(props) {
  const isMobile = useMediaQuery('(max-width:768px)');
  const { getParameter } = useQueryParameters();
  const createmode = getParameter('createmode');

  const [isPdf, setIsPdf] = useState(false);

  const { borderData } = props;
  const { holdTemplateName } = useSelector(state => state.fileList);

  const { selectedFile } = useSelector(state => state.fileList);

  useEffect(() => {
    //check for pdf
    if (selectedFile && selectedFile?.length > 0 && selectedFile[0]?.type === 'pdf' && createmode === 'false') {
      setIsPdf(true);
    }
  }, [selectedFile]);

  //trying word export
  const exportToWord = () => {
    if (createmode === 'true') {
      generateWordfromhtml();
    } else if (createmode === 'false') {
      let checkPdf = { val: false };
      if (selectedFile.length > 0) {
        selectedFile.map(el => {
          if (el.type === 'pdf') {
            checkPdf.val = true;
          } else {
            checkPdf.val = false;
          }
        });
      }

      if (checkPdf.val) {
        return selectedFile.forEach(file => downloadWordFile(file.dataUrl, file.name));
      } else {
        generateWordfromhtml();
      }
    }
  };

  function ExportToPDF() {
    if (createmode === 'true') {
      generatePdffromhtml('.pdf');
    } else if (createmode === 'false') {
      let checkPdf = { val: false };
      if (selectedFile.length > 0) {
        selectedFile.map(el => {
          if (el.type === 'pdf') {
            checkPdf.val = true;
          } else {
            checkPdf.val = false;
          }
        });
      }

      if (checkPdf.val) {
        return selectedFile.forEach(file => downloadPDF(file.dataUrl, file.name));
      } else {
        generatePdffromhtml('.pdf');
      }
    }
  }
  const generateWordfromhtml = () => {
    const elementToExport = props.getEditorContent();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = elementToExport;
    tempDiv.classList.add('ck-content');

    generatePdffromhtml('.docx');
  };
  const generatePdffromhtml = type => {
    const elementHTML = props.getEditorContent(true, false);

    // Check if the HTML element exists
    //if (elementHTML) {
    // Create a new jsPDF instance
    const doc = new jsPDF();

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = elementHTML;

    const checkEditorTag = tempDiv.querySelector('#editor');

    if (!checkEditorTag) {
      tempDiv.id = 'editor';
      tempDiv.classList.add(
        'ck-content',
        'ck-restricted-editing_mode_standard',
        'ck-blurred',
        'ck',
        'ck-editor__editable',
        'ck-rounded-corners',
        'ck-editor__editable_inline'
      );
    }

    mapTables(tempDiv);
    // Convert HTML to PDF
    doc.html(tempDiv, {
      callback: async function (doc) {
        if (borderData.border >= 1) {
          for (let i = 0; i < doc.getNumberOfPages(); i++) {
            doc.setPage(i + 1);
            doc.setDrawColor(0, 0, 0);

            if (borderData.border > 4) {
              doc.setLineWidth(4);
            } else {
              doc.setLineWidth(borderData.border);
            }
            doc.rect(5, 5, doc.internal.pageSize.width - 10, doc.internal.pageSize.height - 10, 'S');
          }
        }
        if (type === '.docx') {
          const fileData = doc.output('datauristring');
          const pdfDoc = await PDFDocument.load(fileData);

          // Create a new Word document
          const wordDoc = await PDFDocument.create();

          const pdfPages = pdfDoc.getPages();

          let count = 0;
          for (const pdfPage of pdfPages) {
            const [wordPage] = await wordDoc.copyPages(pdfDoc, [count]);
            wordDoc.addPage(wordPage);
            count++;
          }

          // Save the Word document as a Uint8Array
          const wordBytes = await wordDoc.save();

          // Create a Blob from the Uint8Array
          const wordBlob = new Blob([wordBytes], {
            type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          });

          // Create a download link and trigger the download
          const downloadLink = document.createElement('a');
          downloadLink.href = URL.createObjectURL(wordBlob);
          downloadLink.download = holdTemplateName ? holdTemplateName + type : 'document.docx';
          downloadLink.click();
        } else {
          doc.save(holdTemplateName + type);
        }
      },
      margin: [5, 5, 5, 5],
      autoPaging: 'text',
      x: 0,
      y: 0,
      width: 190, // target width in the PDF document
      windowWidth: 675 // window width in CSS pixels
    });
    //}
  };
  return (
    <Box display={'flex'} mt={isMobile ? 2 : 3} flexDirection={'column'} width={'100%'} rowGap={isMobile ? 1 : 2}>
      <PrimaryButton
        value={isPdf ? 'Export' : 'Export to PDF'}
        onClick={ExportToPDF}
        backgroundColor={'#B7D423'}
        width={'100%'}
        height={isMobile && '35px'}
        btnClass='template-save_btn'
        textcolor={'#21241E'}
        customStyle={{
          border: '1px solid #b7d423',
          fontFamily: 'Gilroy-SemiBold'
        }}
      />
    </Box>
  );
}
export default CKEditoruploadcomp;
